import { apiClient } from './apiClient';
import { TIMEOUT_IMPORTACION_MS } from './importacionService';

class PlanService {
  // === Planes ===
  async obtenerPlanes(filtros = {}) {
    const params = new URLSearchParams();
    Object.entries(filtros).forEach(([key, value]) => {
      if (value) params.append(key, value);
    });
    
  const response = await apiClient.get(`/planes-mantenimiento/`, { params });
    return response.data;
  }

  async obtenerPlan(id) {
  const response = await apiClient.get(`/planes-mantenimiento/${id}/`);
    return response.data;
  }

  async crearPlan(datos) {
  const response = await apiClient.post(`/planes-mantenimiento/`, datos);
    return response.data;
  }

  async actualizarPlan(id, datos) {
  const response = await apiClient.put(`/planes-mantenimiento/${id}/`, datos);
    return response.data;
  }

  async eliminarPlan(id) {
  await apiClient.delete(`/planes-mantenimiento/${id}/`);
  }

  async clonarPlan(id, datos = {}) {
    const response = await apiClient.post(`/planes-mantenimiento/${id}/clonar/`, datos);
    return response.data;
  }

  async asignarAutomaticamente() {
  const response = await apiClient.post(`/planes-mantenimiento/asignar-automaticamente/`);
    return response.data;
  }

  async resumenGlobalPlanes() {
  const response = await apiClient.get(`/planes-mantenimiento/resumen/`);
    return response.data;
  }

  async resumenPlan(id) {
  const response = await apiClient.get(`/planes-mantenimiento/${id}/resumen/`);
    return response.data;
  }

  // === Rutinas ===
  async obtenerRutinas(filtros = {}) {
    const params = new URLSearchParams();
    Object.entries(filtros).forEach(([key, value]) => {
      if (value) params.append(key, value);
    });
    
  const response = await apiClient.get(`/rutinas-mantenimiento/`, { params });
    return response.data;
  }

  async obtenerRutinasPorPlan(planId) {
  const response = await apiClient.get(`/rutinas-mantenimiento/`, { params: { plan: planId } });
    return response.data;
  }

  async obtenerRutina(id) {
  const response = await apiClient.get(`/rutinas-mantenimiento/${id}/`);
    return response.data;
  }

  async crearRutina(data) {
  const response = await apiClient.post(`/rutinas-mantenimiento/`, data);
    return response.data;
  }

  async actualizarRutina(id, data) {
  const response = await apiClient.put(`/rutinas-mantenimiento/${id}/`, data);
    return response.data;
  }

  async eliminarRutina(id) {
  await apiClient.delete(`/rutinas-mantenimiento/${id}/`);
  }

  async clonarRutina(id, payload = {}) {
  const response = await apiClient.post(`/rutinas-mantenimiento/${id}/clonar/`, payload);
    return response.data;
  }

  // === Tareas ===
  async obtenerTareas(filtros = {}) {
    const params = new URLSearchParams();
    Object.entries(filtros).forEach(([key, value]) => {
      if (value) params.append(key, value);
    });
    
  // Backend route is 'tareas' (TareaViewSet), not 'tareas-mantenimiento'
  const response = await apiClient.get(`/tareas/`, { params });
    return response.data;
  }

  async buscarTareas(q) {
  const response = await apiClient.get(`/tareas-busqueda/`, { params: { q } });
    return response.data?.tareas || [];
  }

  // === Tareas por rutina (detalle de rutina) ===
  async obtenerTareasDeRutina(rutinaId) {
  const response = await apiClient.get(`/rutinas-tareas/`, { params: { rutina: rutinaId, page_size: 9999 } });
    return response.data;
  }

  async agregarTareaARutina(payload) {
  const response = await apiClient.post(`/rutinas-tareas/`, payload);
    return response.data;
  }

  async actualizarTareaDeRutina(id, payload) {
  const response = await apiClient.put(`/rutinas-tareas/${id}/`, payload);
    return response.data;
  }

  async eliminarTareaDeRutina(id) {
  await apiClient.delete(`/rutinas-tareas/${id}/`);
  }

  async descargarPlantillaTareas(rutinaId) {
    const response = await apiClient.get(`/rutinas-mantenimiento/${rutinaId}/importar-tareas/plantilla/`, {
      responseType: 'blob',
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    const cd = response.headers['content-disposition'] || '';
    const match = cd.match(/filename="?([^"]+)"?/);
    link.setAttribute('download', match ? match[1] : 'plantilla_tareas.xlsx');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  }

  async importarTareasDesdeExcel(rutinaId, archivo) {
    const formData = new FormData();
    formData.append('archivo', archivo);
    const response = await apiClient.post(
      `/rutinas-mantenimiento/${rutinaId}/importar-tareas/`,
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: TIMEOUT_IMPORTACION_MS,
      },
    );
    return response.data;
  }

  // === Planes asignados a equipos ===
  async obtenerAsignados(filtros = {}) {
    const params = new URLSearchParams();
    Object.entries(filtros).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') params.append(key, value);
    });
    const response = await apiClient.get(`/planes-asignados/`, { params });
    return response.data;
  }

  async actualizarAsignado(id, data) {
    const response = await apiClient.patch(`/planes-asignados/${id}/`, data);
    return response.data;
  }

  // Plan del equipo, o null si no tiene ninguno asignado.
  async obtenerAsignadoDeEquipo(equipoId) {
    if (!equipoId) return null;
    const data = await this.obtenerAsignados({ equipo: equipoId });
    const filas = data?.results || data || [];
    return Array.isArray(filas) ? (filas[0] || null) : null;
  }

  // Estado del plan del equipo: lo que tiene asignado (si tiene algo) y lo que le
  // correspondería por marca/modelo/contador. A diferencia de obtenerAsignadoDeEquipo,
  // responde también cuando el equipo no tiene ninguna fila de PlanAsignado — es lo
  // que permite ofrecer "restablecer automático" sin que el usuario tenga que elegir
  // un plan a mano primero solo para que aparezca el botón.
  async obtenerEstadoPlanDeEquipo(equipoId) {
    const response = await apiClient.get(`/planes-asignados/estado/`, { params: { equipo: equipoId } });
    return response.data;
  }

  // Fija un plan a mano. Queda 'manual': la asignación automática por
  // marca/modelo/contador no lo vuelve a tocar.
  async asignarPlanManual(equipoId, planId) {
    const response = await apiClient.post(`/planes-asignados/asignar-manual/`, {
      equipo: equipoId, plan: planId,
    });
    return response.data;
  }

  // Devuelve el equipo al plan que le corresponde por marca/modelo/contador.
  async restaurarPlanAutomatico(equipoId) {
    const response = await apiClient.post(`/planes-asignados/restaurar-automatico/`, {
      equipo: equipoId,
    });
    return response.data;
  }

  // Deja al equipo explícitamente sin plan: además de desvincularlo, apaga la
  // gestión de plan del equipo, porque si no la asignación automática lo
  // volvería a crear en el próximo guardado.
  async quitarPlan(equipoId) {
    const response = await apiClient.post(`/planes-asignados/quitar/`, { equipo: equipoId });
    return response.data;
  }

  // El usuario revisó el desajuste y se queda con este plan.
  async confirmarRevisionPlan(equipoId) {
    const response = await apiClient.post(`/planes-asignados/confirmar-revision/`, { equipo: equipoId });
    return response.data;
  }

  // Equipos con historial de mantenimiento que hoy no tienen plan asignado.
  async equiposSinPlan() {
    const response = await apiClient.get(`/planes-asignados/sin-plan/`);
    return response.data || [];
  }

  // === Plan asignado: establecer ancla inicial ===
  async setInicial(payload = {}) {
    // payload: { equipo: number, odometro: number, fecha?: 'YYYY-MM-DD', rutina?: number, observaciones?: string }
    const response = await apiClient.post(`/planes-asignados/set-inicial/`, payload);
    return response.data;
  }

  async compatibleTeoricos(params = {}) {
    // params: { equipo: number, odometro: number }
    const response = await apiClient.get(`/planes-asignados/compatible-teoricos/`, { params });
    return response.data;
  }
}

export const planService = new PlanService();
